module.exports = __webpack_public_path__ + "static/img/0694.d80859ca.png";